import type { OtaBookingRefundLedger, OtaEarlyDepartureReason } from '@/shared/api';
import { Input, Select } from '@/shared/components';
import { formatDate, formatMoney } from '@/shared/lib/format';
import { majorFromMinor } from '@/shared/lib/money';

type Props = {
  checkOutDate: string;
  departureDate: string;
  reason: OtaEarlyDepartureReason;
  refundAmount: string;
  refundReason: string;
  ledger?: OtaBookingRefundLedger;
  pending: boolean;
  onReasonChange: (value: OtaEarlyDepartureReason) => void;
  onRefundAmountChange: (value: string) => void;
  onRefundReasonChange: (value: string) => void;
};

export function OtaEarlyDepartureActualFields(props: Props) {
  const lastNight = new Date(`${props.checkOutDate}T00:00:00Z`);
  lastNight.setUTCDate(lastNight.getUTCDate() - 1);
  return (
    <>
      <p className="bg-navy/5 text-ink-soft rounded-md px-3 py-2 text-xs">
        Frei werdende Nächte: ab {props.departureDate ? formatDate(props.departureDate) : '—'} bis{' '}
        {formatDate(lastNight.toISOString().slice(0, 10))}. Bereits belegte Nächte und manuelle
        Sperren bleiben geschlossen.
      </p>
      <label className="text-ink flex flex-col gap-1.5 text-sm font-medium">
        Grund
        <Select
          value={props.reason}
          disabled={props.pending}
          onChange={(event) => props.onReasonChange(event.target.value as OtaEarlyDepartureReason)}
        >
          <option value="Private">Privat</option>
          <option value="Defect">Mangel mit externer Erstattung</option>
        </Select>
      </label>
      {props.reason === 'Defect' && (
        <>
          <label className="text-ink flex flex-col gap-1.5 text-sm font-medium">
            Bereits extern erstatteter Betrag
            <Input
              type="number"
              min="0.01"
              step="0.01"
              inputMode="decimal"
              value={props.refundAmount}
              disabled={props.pending}
              onChange={(event) => props.onRefundAmountChange(event.target.value)}
            />
          </label>
          <p className="text-ink-faint text-xs">
            Verbleibend:{' '}
            {props.ledger
              ? formatMoney(
                  majorFromMinor(props.ledger.remainingGrossMinor, props.ledger.currency),
                  props.ledger.currency,
                )
              : 'wird geladen'}
          </p>
          <label className="text-ink flex flex-col gap-1.5 text-sm font-medium">
            Geschäftlicher Grund
            <Input
              value={props.refundReason}
              maxLength={500}
              disabled={props.pending}
              onChange={(event) => props.onRefundReasonChange(event.target.value)}
            />
          </label>
        </>
      )}
    </>
  );
}
